import { ajaxAuth, createBufferedRequestFunction, notUndefinedOrNull } from "@tm/utils"
import { CompilationsContainsRequest, CompilationsContainsResponse } from "."
import { WebserviceUrl } from "../../webserviceUrls"

export const getContainingArticlesBuffered = createBufferedRequestFunction<
    CompilationsContainsRequest[],
    CompilationsContainsResponse[],
    CompilationsContainsResponse[]
>({
    callService: (requests) => showContainingArticles(requests.reduce((prev, cur) => [...prev, ...cur], [])),
    mapServiceResponseToResponse: (serviceResponse, request) => {
        const includedInLists = serviceResponse.filter((compilationItem) =>
            request.some(
                (y) =>
                    compilationItem.supplierArticleNumber === y.supplierArticleNumber &&
                    compilationItem.supplierId === y.supplierId &&
                    compilationItem.productGroupId === y.productGroupId
            )
        )

        return includedInLists.length ? includedInLists : []
    },
})

export function showContainingArticles(articles: CompilationsContainsRequest[]): Promise<CompilationsContainsResponse[]> {
    const url = `${WebserviceUrl.CompilationsArticleCompilationsEmbedded}/CompilationsContain`

    return ajaxAuth<{ compilationItemIds: CompilationsContainsResponse[] }>({
        url,
        body: { articleNumbers: articles },
        method: "POST",
    }).then((data) => data?.compilationItemIds?.filter(notUndefinedOrNull) || [])
}
